import React from 'react';

export default function FAQs() {
  return (
    <div className="min-h-screen bg-gray-800 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        {/* Header Section */}
        <h1 className="text-4xl font-bold text-gray-100 mb-8 text-center">
          FAQs
        </h1>

        {/* What is Bitcoin? */}
        <section className="mb-12 bg-gray-700 p-6 rounded-lg shadow-md">
          <h2 className="text-2xl font-semibold text-gray-100 mb-4">
            What is Bitcoin?
          </h2>
          <p className="text-gray-300 leading-relaxed">
            Bitcoin is a form of digital currency which is based on an open-source code that was created and is held electronically. 
            Bitcoin is a decentralized form of currency, meaning that it does not belong to any form of government and is not controlled by anyone.
          </p>
        </section>

        {/* Who developed Bitcoin? */}
        <section className="mb-12 bg-gray-700 p-6 rounded-lg shadow-md">
          <h2 className="text-2xl font-semibold text-gray-100 mb-4">
            Who developed Bitcoin?
          </h2>
          <p className="text-gray-300 leading-relaxed">
            The original Bitcoin code was designed by Satoshi Nakamoto under MIT open-source credentials. In 2008, Nakamoto outlined the idea behind Bitcoin in his White Paper, which scientifically described how the cryptocurrency would function. 
            Bitcoin is the first successful digital currency designed with trust in cryptography over central authorities. 
            Satoshi left the Bitcoin code in the hands of developers and the community in 2010. Thus far, hundreds of developers have added to the core code throughout the years.
          </p>
        </section>

        {/* What is Bitcoin Mining? */}
        <section className="mb-12 bg-gray-700 p-6 rounded-lg shadow-md">
          <h2 className="text-2xl font-semibold text-gray-100 mb-4">
            What is Bitcoin Mining?
          </h2>
          <p className="text-gray-300 leading-relaxed">
            Bitcoin mining is analogous to the mining of gold, but in its digital form. The process involves specialized computers solving algorithmic equations or hash functions. 
            These problems help miners to confirm blocks of transactions held within the network. 
            Bitcoin mining provides a reward for miners by paying out in Bitcoin; in turn, the miners confirm transactions on the blockchain. 
            Miners introduce new Bitcoin into the network and also secure the system with transaction confirmation. 
            They are also rewarded network fees for when they harvest new coins, and even after the last Bitcoin is found, mining will continue.
          </p>
        </section>
      </div>
    </div>
  );
}
